import { render } from "./EnterOneTimePasscode.vue?vue&type=template&id=31619fc6"
import script from "./EnterOneTimePasscode.vue?vue&type=script&lang=js"
export * from "./EnterOneTimePasscode.vue?vue&type=script&lang=js"

import "./EnterOneTimePasscode.vue?vue&type=style&index=0&id=31619fc6&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__